export function onCancelFactory(setCustomGroupForm, customGroup, cancel) {
  return () => {
    setCustomGroupForm({ ...customGroup });
    cancel();
  };
}
